import {
  validateBoolean,
  createObjectValidator,
  validateNumber,
  optionalValidator,
  validateString,
  validateUuidV4
} from "../../../packages/validator/validator.js";

/**
 * One comment stored by the the comments database.
 */
export type Comment = {
  /**
   * Comment ID.
   */
  id: string;
  /**
   * Name of the comment author.
   */
  author: string;
  /**
   * Markdown content of the comment.
   */
  content: string;
  /**
   * Unix timestamp of the comment.
   */
  timestamp: number;
  /**
   * Email of the comment author. Was used in the Blog-Core
   * system.
   */
  email?: string;
  /**
   * UUID version 4 of the post ID.
   */
  postId: string;
  /**
   * Website of the comment author.
   */
  site?: string;
  /**
   * Whether to notify about replies and new comments. Was used
   * in the Blog-Core system.
   */
  notify: boolean;
  /**
   * Slug or the article.
   */
  slug: string;
  /**
   * Title of the article.
   */
  title: string;
};

export const validateComment = createObjectValidator<Comment>("Comment", {
  id: validateUuidV4,
  author: validateString,
  content: validateString,
  timestamp: validateNumber,
  email: optionalValidator(validateString),
  postId: validateUuidV4,
  site: optionalValidator(validateString),
  notify: validateBoolean,
  slug: validateString,
  title: validateString
});
